import { api, client } from "@/client";
import { useAuthenticationStore } from "@/stores/authentication";
import { StorageSerializers, useStorage } from "@vueuse/core";
import { defineStore, acceptHMRUpdate } from "pinia";
import { Client } from "typesense";

export const useTypesenseStore = defineStore("typesense", {
  state: () => ({
    loading: false,
    packageList: [] as any,
    aipDipDetails: [] as any,
    totalRecords: 0,
    test: {},
    key: "" as string,
    expiry: 0 as number,
    currentContent: {} as any,
    searchKey: null as api.KeysResponseBody | null,
    typesenseheader: "" as string | undefined,
    eventList: [] as any,
    currentEvent: {} as any,
    currentFile: {} as any,
    serverParams: {
      filter_by: "",
      sort_by: "",
      q: "*",
      query_by: "transfer_batch,transfer_agency,sip_uuid,transfer_uuid,item_id",
      page: 1,
      per_page: 20,
    } as any,
    searchField: {
      transfer_batch: "",
      transfer_agency: "",
      security_grading: "",
      sensitivity_classification: "",
      status: "",
      transfer_date: "",
      type: "",
      fixity_check_passed: "",
      fixity_checked_at: "",
    } as any,
    searchData: {
      raw_transfer_date: "",
      aip: true,
      dip: true,
      fixity_checked_at_start: "",
      fixity_checked_at_end: "",
    } as any,
  }),
  getters: {},
  actions: {
    async fetchTypesense(type, searchParameters) {
      this.loading = true;

      const key = useStorage("search-api-keys", this.searchKey, undefined, {
        serializer: StorageSerializers.object,
      });
      const inOneMinute = Math.floor(Date.now() / 1000) + 60;
      if (!key.value || key.value.expiresAt < inOneMinute) {
        key.value = await client.search.searchKeys();
      }
      this.searchKey = key.value;
      // check type to select search key

      if (type != "secure-zone-downloads") {
        this.typesenseheader = this.searchKey?.packagesKey;
      } else {
        this.typesenseheader = this.searchKey?.downloadsKey;
      }

      const x = new Client({
        nodes: [
          {
            host: import.meta.env.VITE_TYPESENSE_ADDR,
            port: import.meta.env.VITE_TYPESENSE_PORT,
            path: import.meta.env.VITE_TYPESENSE_NAME,
            protocol: import.meta.env.VITE_PROTOCOL,
          },
        ],

        apiKey: String(this.typesenseheader),
        // apiKey: String("typesenseapikey"),
        connectionTimeoutSeconds: 20,
      });

      x.collections(type)
        //.collections("secure-zone-packages")
        .documents()
        .search(searchParameters)
        .then((result: any) => {
          this.reset();
          // if (type != "secure-zone-files") {
          this.totalRecords = result.found;
          for (let index = 0; index < result.hits.length; index++) {
            const element = result.hits[index].document;
            // to add new element to disable checkbox base on selectd field
            // if (element.status === "Reingesting")
            //   element.checkboxDisabled = true;
            this.packageList.push(element);
          }
          this.currentContent = this.packageList[0];
          // }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchCurrent(params: any) {
      this.$reset;
      this.currentContent = params.row;
      // console.log("a",this.currentContent);
    },

    async fetchTypesenseEvent(searchParameters) {
      this.loading = true;
      this.eventList = [];

      const key = useStorage("search-api-keys", this.searchKey, undefined, {
        serializer: StorageSerializers.object,
      });
      const inOneMinute = Math.floor(Date.now() / 1000) + 60;
      if (!key.value || key.value.expiresAt < inOneMinute) {
        key.value = await client.search.searchKeys();
      }
      this.searchKey = key.value;
      this.typesenseheader = this.searchKey?.packagesKey;

      const x = new Client({
        nodes: [
          {
            host: import.meta.env.VITE_TYPESENSE_ADDR,
            port: import.meta.env.VITE_TYPESENSE_PORT,
            path: import.meta.env.VITE_TYPESENSE_NAME,
            protocol: import.meta.env.VITE_PROTOCOL,
          },
        ],
        apiKey: String(this.typesenseheader),
        connectionTimeoutSeconds: 20,
      });

      x.collections("secure-zone-events")
        .documents()
        .search(searchParameters)
        .then((result: any) => {
          for (let index = 0; index < result.hits.length; index++) {
            const element = result.hits[index].document;
            this.eventList.push(element);
          }
          this.currentEvent = this.eventList[0];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    removeSearchKeys() {
      const keys = useStorage("search-api-keys", this.searchKey, undefined, {
        serializer: StorageSerializers.object,
      });
      this.searchKey = keys.value = null;
    },

    async fetchTypesenseFile(searchParameters) {
      this.loading = true;

      const key = useStorage("search-api-keys", this.searchKey, undefined, {
        serializer: StorageSerializers.object,
      });
      const inOneMinute = Math.floor(Date.now() / 1000) + 60;
      if (!key.value || key.value.expiresAt < inOneMinute) {
        key.value = await client.search.searchKeys();
      }
      this.searchKey = key.value;
      this.typesenseheader = this.searchKey?.packagesKey;

      const x = new Client({
        nodes: [
          {
            host: import.meta.env.VITE_TYPESENSE_ADDR,
            port: import.meta.env.VITE_TYPESENSE_PORT,
            path: import.meta.env.VITE_TYPESENSE_NAME,
            protocol: import.meta.env.VITE_PROTOCOL,
          },
        ],
        apiKey: String(this.typesenseheader),
        connectionTimeoutSeconds: 20,
      });

      x.collections("secure-zone-files")
        .documents()
        .search(searchParameters)
        .then((result: any) => {
          this.reset();
          this.currentFile = result.hits[0].document;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    storeData(serverParams) {
      this.serverParams = serverParams;
    },

    storeSearchBar(searchField, searchData) {
      this.searchField = searchField;
      this.searchData = searchData;
    },

    storePageDetails(currentPage, currentPerPage) {
      this.serverParams.page = currentPage;
      this.serverParams.per_page = currentPerPage;
    },

    confirm(locationName: string) {},
    reject() {},
    reset() {
      this.packageList = [];
      this.removeSearchKeys();
    },
  },
});
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTypesenseStore, import.meta.hot));
}
